<template>
    <velt-wireframe style="display:none;">
        <!-- Comment Dialog Composer Submit Button Override -->
        <velt-comment-dialog-composer-action-button-wireframe type="submit">
            <pendo-button
                class="submit-comment-button"
                icon="arrow-right"
                icon-size="16" />
        </velt-comment-dialog-composer-action-button-wireframe>

        <!-- Comment Dialog options override -->
        <velt-comment-dialog-options-dropdown-content-wireframe>
            <div class="comment-dialog-options-dropdown">
                <velt-comment-dialog-options-dropdown-content-notification-wireframe>
                    <velt-comment-dialog-options-dropdown-content-notification-subscribe-wireframe>
                        <div class="pendo-multiselect-option">
                            <pendo-icon
                                type="bell"
                                size="16" />
                            <span class="pendo-multiselect-label">Subscribe</span>
                        </div>
                    </velt-comment-dialog-options-dropdown-content-notification-subscribe-wireframe>
                    <velt-comment-dialog-options-dropdown-content-notification-unsubscribe-wireframe>
                        <div class="pendo-multiselect-option">
                            <pendo-icon
                                type="bell-off"
                                size="16" />
                            <span class="pendo-multiselect-label">Unsubscribe</span>
                        </div>
                    </velt-comment-dialog-options-dropdown-content-notification-unsubscribe-wireframe>
                </velt-comment-dialog-options-dropdown-content-notification-wireframe>
                <velt-comment-dialog-options-dropdown-content-edit-wireframe>
                    <div class="pendo-multiselect-option">
                        <pendo-icon
                            type="edit"
                            size="16" />
                        <span class="pendo-multiselect-label">Edit</span>
                    </div>
                </velt-comment-dialog-options-dropdown-content-edit-wireframe>
                <velt-comment-dialog-options-dropdown-content-delete-wireframe>
                    <div class="pendo-multiselect-option">
                        <pendo-icon
                            type="trash-2"
                            size="16" />
                        <span class="pendo-multiselect-label">Delete</span>
                    </div>
                </velt-comment-dialog-options-dropdown-content-delete-wireframe>
            </div>
        </velt-comment-dialog-options-dropdown-content-wireframe>

        <!-- Reaction Tool Button Override -->
        <velt-reaction-tool-wireframe>
            <pendo-icon-button
                icon="smile"
                fill="var(--palette-gray-70)"
                icon-size="16" />
        </velt-reaction-tool-wireframe>

        <!-- Sidebar Button -->
        <velt-sidebar-button-icon-wireframe>
            <div class="icon-container">
                <pendo-icon
                    type="message-circle"
                    stroke="var(--palette-teal-70)"
                    size="16" />
                <velt-if condition="{unreadCommentAnnotationCount} > 0">
                    <div class="unread-indicator" />
                </velt-if>
            </div>
        </velt-sidebar-button-icon-wireframe>

        <!-- Sidebar Status Dropdown Override -->
        <velt-comments-sidebar-status-dropdown-wireframe>
            <velt-comments-sidebar-status-dropdown-trigger-wireframe>
                <div
                    class="sidebar-status-dropdown-trigger"
                    :onclick="statusDropdownInlineClickHandler">
                    <span class="sidebar-status-dropdown-trigger--text">Status</span>
                    <pendo-icon
                        type="chevron-down"
                        stroke="var(--palette-gray-100)"
                        size="14" />
                </div>
            </velt-comments-sidebar-status-dropdown-trigger-wireframe>
            <velt-comments-sidebar-status-dropdown-content-wireframe />
        </velt-comments-sidebar-status-dropdown-wireframe>

        <!-- Sidebar -->
        <velt-comments-sidebar-wireframe>
            <velt-comments-sidebar-skeleton-wireframe />
            <velt-comments-sidebar-panel-wireframe>
                <velt-comments-sidebar-header-wireframe>
                    <!-- Tabs for widget and page comments -->
                    <pendo-radio-group
                        class="velt-comments-sidebar-radio-group"
                        button>
                        <velt-comments-sidebar-action-button-wireframe
                            id="widget"
                            type="default">
                            <pendo-radio-button
                                value="widget"
                                label="Widget" />
                        </velt-comments-sidebar-action-button-wireframe>
                        <velt-comments-sidebar-action-button-wireframe
                            id="page"
                            type="default">
                            <pendo-radio-button
                                value="page"
                                label="Page" />
                        </velt-comments-sidebar-action-button-wireframe>
                    </pendo-radio-group>
                    <div class="sidebar-header--filter">
                        <velt-comments-sidebar-status-wireframe />
                        <velt-comments-sidebar-filter-button-wireframe>
                            <div
                                class="sidebar-filter-dropdown-trigger"
                                :onclick="filterDropdownInlineClickHandler">
                                <span class="sidebar-filter-dropdown-trigger--text">Filter by</span>
                                <pendo-icon
                                    type="chevron-down"
                                    stroke="var(--palette-gray-100)"
                                    size="14" />
                            </div>
                        </velt-comments-sidebar-filter-button-wireframe>
                    </div>
                </velt-comments-sidebar-header-wireframe>
                <velt-comments-sidebar-filter-wireframe />
                <velt-comments-sidebar-list-wireframe />
                <velt-comments-sidebar-empty-placeholder-wireframe>
                    <velt-if condition="{customActionsState.widget} === true">
                        <div class="collaboration-sidebar-empty-state widget">
                            <img src="@img/collaboration/collaboration-comments.svg">
                            <div class="collaboration-sidebar-empty-state__header">
                                No comments found
                            </div>
                            <div class="collaboration-sidebar-empty-state__body">
                                <velt-if condition="{commentAnnotations.length} === 0">
                                    Share your thoughts, ask questions, or propose actions. Start collaborating by
                                    adding a comment on a widget.
                                </velt-if>
                                <velt-if condition="{commentAnnotations.length} > 0">
                                    Add a new comment on a widget or change your filters to view existing discussions.
                                </velt-if>
                            </div>
                        </div>
                    </velt-if>
                    <velt-if condition="{customActionsState.page} === true">
                        <div class="collaboration-sidebar-empty-state">
                            <img src="@img/collaboration/collaboration-comments.svg">
                            <div class="collaboration-sidebar-empty-state__header">
                                No comments found
                            </div>
                            <div class="collaboration-sidebar-empty-state__body">
                                <velt-if condition="{commentAnnotations.length} === 0">
                                    Share your thoughts, ask questions, or propose actions. Start collaborating by
                                    adding a comment below.
                                </velt-if>
                                <velt-if condition="{commentAnnotations.length} > 0">
                                    Add a new comment below or change your filters to view existing discussions.
                                </velt-if>
                            </div>
                        </div>
                    </velt-if>
                </velt-comments-sidebar-empty-placeholder-wireframe>
                <velt-if condition="{customActionsState.page} === true">
                    <velt-comments-sidebar-page-mode-composer-wireframe />
                </velt-if>
            </velt-comments-sidebar-panel-wireframe>
        </velt-comments-sidebar-wireframe>

        <velt-comments-sidebar-list-item-group-wireframe>
            <div class="sidebar-list-item-group">
                <div class="sidebar-list-item-name">
                    <velt-comments-sidebar-list-item-group-name-wireframe />
                </div>
                <div class="count-container">
                    (<velt-comments-sidebar-list-item-group-count-wireframe />)
                </div>
                <velt-comments-sidebar-list-item-group-arrow-wireframe>
                    <pendo-icon
                        type="chevron-down"
                        size="16" />
                </velt-comments-sidebar-list-item-group-arrow-wireframe>
            </div>
        </velt-comments-sidebar-list-item-group-wireframe>

        <!-- Empty sidebar skeleton to prevent default loading skeleton -->
        <velt-comments-sidebar-skeleton-wireframe>
            <div />
        </velt-comments-sidebar-skeleton-wireframe>

        <!-- Sidebar status filter -->
        <velt-comments-sidebar-status-dropdown-content-wireframe>
            <velt-comments-sidebar-status-dropdown-content-item-wireframe>
                <div class="velt-comments-sidebar-filter-item">
                    <velt-comments-sidebar-status-dropdown-content-item-checkbox-wireframe>
                        <velt-comments-sidebar-status-dropdown-content-item-checkbox-unchecked-wireframe>
                            <pendo-checkbox />
                        </velt-comments-sidebar-status-dropdown-content-item-checkbox-unchecked-wireframe>
                        <velt-comments-sidebar-status-dropdown-content-item-checkbox-checked-wireframe>
                            <pendo-checkbox :value="true" />
                        </velt-comments-sidebar-status-dropdown-content-item-checkbox-checked-wireframe>
                    </velt-comments-sidebar-status-dropdown-content-item-checkbox-wireframe>
                    <velt-comments-sidebar-status-dropdown-content-item-icon-wireframe />
                    <div class="filter-item-label">
                        <velt-comments-sidebar-status-dropdown-content-item-name-wireframe />
                        <div class="filter-item-count">
                            (<velt-comments-sidebar-status-dropdown-content-item-count-wireframe />)
                        </div>
                    </div>
                </div>
            </velt-comments-sidebar-status-dropdown-content-item-wireframe>
        </velt-comments-sidebar-status-dropdown-content-wireframe>

        <!-- Sidebar "filter" filter -->
        <velt-comments-sidebar-filter-wireframe>
            <!-- People -->
            <velt-comments-sidebar-filter-people-wireframe />
        </velt-comments-sidebar-filter-wireframe>

        <velt-comments-sidebar-filter-item-wireframe>
            <div class="velt-comments-sidebar-filter-item">
                <velt-comments-sidebar-filter-item-checkbox-wireframe>
                    <velt-comments-sidebar-filter-item-checkbox-checked-wireframe>
                        <span class="checked" />
                    </velt-comments-sidebar-filter-item-checkbox-checked-wireframe>
                </velt-comments-sidebar-filter-item-checkbox-wireframe>

                <div class="filter-item-label">
                    <velt-comments-sidebar-filter-item-name-wireframe />
                    <div class="filter-item-count">
                        (<velt-comments-sidebar-filter-item-count-wireframe />)
                    </div>
                </div>
            </div>
        </velt-comments-sidebar-filter-item-wireframe>

        <!-- Comment Dialog -->
        <velt-comment-dialog-wireframe variant="dialog">
            <div class="comment-dialog-container">
                <velt-comment-dialog-assignee-banner-wireframe />

                <velt-comment-dialog-header-wireframe>
                    <div class="header-container">
                        <velt-comment-dialog-status-wireframe />
                        <div class="header-actions">
                            <velt-comment-dialog-resolve-button-wireframe>
                                <pendo-icon-button icon="check-circle-2" />
                            </velt-comment-dialog-resolve-button-wireframe>
                            <velt-comment-dialog-copy-link-wireframe>
                                <pendo-icon-button icon="link" />
                            </velt-comment-dialog-copy-link-wireframe>
                            <velt-comment-dialog-options-wireframe />
                        </div>
                    </div>
                </velt-comment-dialog-header-wireframe>
                <velt-comment-dialog-body-wireframe />

                <velt-comment-dialog-composer-wireframe>
                    <velt-comment-dialog-composer-input-wireframe placeholder="Add a comment..." />
                    <velt-comment-dialog-composer-action-button-wireframe type="submit" />
                </velt-comment-dialog-composer-wireframe>
            </div>
        </velt-comment-dialog-wireframe>

        <!-- Comment Dialog: Sidebar -->
        <velt-comment-dialog-wireframe variant="sidebar">
            <div class="comment-dialog-container">
                <velt-comment-dialog-assignee-banner-wireframe />

                <velt-comment-dialog-header-wireframe>
                    <div class="header-container">
                        <velt-comment-dialog-status-wireframe />
                        <div class="header-actions">
                            <velt-comment-dialog-resolve-button-wireframe>
                                <pendo-icon-button icon="check-circle-2" />
                            </velt-comment-dialog-resolve-button-wireframe>
                            <velt-comment-dialog-copy-link-wireframe>
                                <pendo-icon-button icon="link" />
                            </velt-comment-dialog-copy-link-wireframe>
                            <velt-comment-dialog-options-wireframe />
                        </div>
                    </div>
                </velt-comment-dialog-header-wireframe>
                <div class="widget-title-container">
                    <pendo-icon
                        class="bar-chart-icon"
                        type="bar-chart-2"
                        size="12" />
                    <velt-data
                        class="widget-title-text"
                        path="commentAnnotation.context.widgetTitle" />
                </div>
                <velt-comment-dialog-body-wireframe />

                <velt-comment-dialog-composer-wireframe variant="dialog">
                    <velt-comment-dialog-composer-input-wireframe placeholder="Add a comment..." />
                    <velt-comment-dialog-composer-action-button-wireframe type="submit" />
                </velt-comment-dialog-composer-wireframe>

                <velt-comment-dialog-all-comment-wireframe />
                <velt-comment-dialog-approve-wireframe />
                <velt-comment-dialog-sign-in-wireframe />
                <velt-comment-dialog-upgrade-wireframe />
                <velt-comment-dialog-suggestion-action-wireframe />
            </div>
        </velt-comment-dialog-wireframe>
        <velt-comment-dialog-status-dropdown-trigger-arrow-wireframe>
            <pendo-icon
                type="chevron-down"
                size="16" />
        </velt-comment-dialog-status-dropdown-trigger-arrow-wireframe>

        <!-- Comment Tool -->
        <velt-comment-tool-wireframe>
            <div class="custom-bubble-tool">
                <div class="bubble-icon">
                    <pendo-icon
                        type="message-circle"
                        size="22" />
                    <pendo-icon
                        size="12px"
                        stroke-width="3px"
                        class="unread-notification"
                        type="circle"
                        stroke="var(--palette-gray-0)"
                        fill="var(--palette-pink-120)" />
                </div>
            </div>
        </velt-comment-tool-wireframe>

        <!-- Comment bubble -->
        <velt-comment-bubble-wireframe>
            <div class="custom-bubble-tool">
                <div class="bubble-icon">
                    <pendo-icon
                        type="message-circle"
                        size="22" />
                    <pendo-icon
                        size="12px"
                        stroke-width="3px"
                        class="unread-notification"
                        type="circle"
                        stroke="var(--palette-gray-0)"
                        fill="var(--palette-pink-120)" />
                </div>
                <span class="velt-comment-annotation-id">
                    <velt-data path="commentAnnotation.annotationId" />
                </span>
                <span class="comment-count" />
            </div>
        </velt-comment-bubble-wireframe>

        <!-- Confirm Dialog -->
        <velt-confirm-dialog-title-wireframe>
            Delete comment thread?
        </velt-confirm-dialog-title-wireframe>
        <velt-confirm-dialog-message-wireframe>
            <p>This action permanently removes the original comment and any replies.</p>
            <p>Are you sure you want to continue?</p>
        </velt-confirm-dialog-message-wireframe>

        <velt-confirm-dialog-approve-button-wireframe>
            <pendo-button
                type="danger"
                label="Delete" />
        </velt-confirm-dialog-approve-button-wireframe>
        <velt-confirm-dialog-reject-button-wireframe>
            <pendo-button
                type="secondary"
                label="Cancel" />
        </velt-confirm-dialog-reject-button-wireframe>
    </velt-wireframe>
</template>

<script>
import {
    PendoIconButton,
    PendoButton,
    PendoIcon,
    PendoCheckbox,
    PendoRadioGroup,
    PendoRadioButton,
} from '@pendo/components';
import { getVeltClient, veltToObservable } from '@/collaboration/collaboration.utils';
import { combineLatest, merge } from 'rxjs';
import { distinctUntilChanged, map, mergeMap, switchMap, groupBy, startWith } from 'rxjs/operators';
import isEqual from 'lodash/isEqual';
import { eventToObservable } from '@utils/event-bus.js';

export default {
    name: 'CollaborationWireframes',
    components: {
        PendoIconButton,
        PendoButton,
        PendoIcon,
        PendoCheckbox,
        PendoRadioButton,
        PendoRadioGroup,
    },
    computed: {
        statusDropdownInlineClickHandler () {
            return this.createInlineClickFn(
                'velt-status-dropdown--content',
                'velt-comments-sidebar-status-dropdown',
                'velt-comments-sidebar-status-open',
            );
        },
        filterDropdownInlineClickHandler () {
            return this.createInlineClickFn(
                'velt-sidebar-filter--container',
                'velt-sidebar-header--filter-button',
                'velt-comments-sidebar-filter-button-open',
            );
        },
    },
    async created () {
        const client = await getVeltClient();
        const commentElement = client.getCommentElement();
        const annotations$ = this.createAnnotationObservable(commentElement);
        annotations$.subscribe(this.handleAnnotationEvent);

        this.trackEventHandler = commentElement.onCommentUpdate().subscribe(this.commentUpdateFn);
    },
    beforeUnmount () {
        this.trackEventHandler?.unsubscribe();
    },
    methods: {
        commentUpdateFn (event) {
            if (!['reactionAdded', 'newlyAdded', 'added', 'statusChanged'].includes(event.type)) {
                return;
            }

            let eventName = '';
            const eventData = {};
            eventData.commentId = event.annotation.annotationId;
            eventData.numComments = event.annotation.comments?.length;
            eventData.location = event.annotation.location?.locationName ?? event.annotation.context?.location;

            if (eventData.location === undefined) {
                eventData.location = 'Unknown';
            }

            if (event.annotation.context?.appPlatform) {
                eventData.appPlatform = event.annotation.context.appPlatform;
            }

            switch (event.type) {
                case 'reactionAdded':
                    eventName = 'Collaboration Emoji Added';
                    break;
                case 'statusChanged':
                    eventName = 'Collaboration Status Changed';
                    eventData.isResolved = event.annotation.status?.id === 'resolved';
                    break;
                case 'newlyAdded':
                case 'added':
                    eventName = 'Collaboration Comment Sent';
                    eventData.threadType = event.type === 'newlyAdded' ? 'open' : 'reply';
                    eventData.hasMention =
                        event.annotation.comments?.[event.annotation.comments.length - 1].taggedUserContacts?.length >
                        0;
                    break;
                default:
                    break;
            }

            window.pendo.track(eventName, eventData);
        },
        createAnnotationObservable (commentElement) {
            const annotations$ = veltToObservable(commentElement.getAllCommentAnnotations());
            const intersections$ = eventToObservable('intersectionObserver');

            return annotations$.pipe(
                // Create a stream for each annotation's unread comment count,
                // and watch a merge of all those streams
                switchMap((annotations) => {
                    annotations = annotations || [];

                    const streams = annotations.map(({ annotationId, comments = [] }) => {
                        return veltToObservable(commentElement.getUnreadCommentCountByAnnotationId(annotationId)).pipe(
                            map((observable) => ({
                                id: annotationId,
                                totalCount: comments.length,
                                unreadCount: observable?.count || 0,
                            })),
                        );
                    });

                    return merge(...streams);
                }),

                // Group by annotation ID to filter out duplicate events per thread
                groupBy(({ id }) => id),

                // Merge all events back together after filtering out duplicates
                mergeMap((group$) => {
                    return combineLatest([
                        group$.pipe(distinctUntilChanged(isEqual)),
                        // Use the dashboard's intersection observer to trigger updates
                        // (needed because widgets are lazy-loaded, and we traverse the DOM to add comment counts)
                        intersections$.pipe(startWith(null)),
                    ]).pipe(map(([value]) => value));
                }),
            );
        },
        handleAnnotationEvent ({ id, totalCount, unreadCount }) {
            for (const el of document.querySelectorAll('.velt-comment-annotation-id')) {
                if (el.innerText === id) {
                    const nextEl = el.nextElementSibling;
                    const parentEl = el.parentElement;

                    if (totalCount) {
                        nextEl.innerText = totalCount > 9 ? '9+' : totalCount;
                    } else {
                        nextEl.innerText = '';
                    }
                    parentEl.classList.toggle('unread', unreadCount > 0);

                    break;
                }
            }
        },
        // This handler is specifically for closing the filter/status dropdowns when a user clicks outside of their targets.
        // Velt handles opening them when the toggle is clicked, but doesn't have any kind of "click out to close" functionality
        createInlineClickFn (dropdownContainerClass, dropdownToggleButtonClass, dropdownToggleOpenClass) {
            // Until we can wire javascript more easily into velt components, we'll use an inline click listener to handle toggling the filter dropdown
            return `
                    function unfocusClickHandler(e) {
                        // Ensure the bubbled click from opening the dropdown doesn't also trigger the removal code
                        if(event === e) {
                            return;
                        }

                        const dropdownContainer = e.target.closest('.${dropdownContainerClass}');
                        const isFilterButtonClick = e.target.closest('.${dropdownToggleButtonClass}');

                        if (!dropdownContainer) {
                            document.removeEventListener('click', unfocusClickHandler);
                        }

                        if(!dropdownContainer && !isFilterButtonClick) {
                            const syntheticClick = new MouseEvent('click', { bubbles: false, cancelable: true });
                            const veltFilterContainerWithClickHandler = event.target.closest('.${dropdownToggleOpenClass}');
                            veltFilterContainerWithClickHandler?.dispatchEvent(syntheticClick);
                        }
                    }

                    const isClosingClick = event.target.closest('.${dropdownToggleOpenClass}');
                    if(!isClosingClick) {
                        document.addEventListener('click', unfocusClickHandler);
                    }
            `;
        },
    },
};
</script>

<!-- rather than littering our css with :deep, we'll leave these styles unscoped, and
     wrap them with containing classes to make sure they don't bleed elsewhere -->
<!-- eslint-disable-next-line vue-scoped-css/enforce-style-type -->
<style lang="less">
.cdk-overlay-container {
    @import '@/collaboration/wireframes/velt-global-style-overrides/floating-dropdowns.less';
}

.collaboration-side-drawer {
    @import '@/collaboration/wireframes/velt-global-style-overrides/sidebar.less';
}

.collaboration-side-drawer-button {
    @import '@/collaboration/wireframes/velt-global-style-overrides/sidebar-button.less';
}

.collaboration-pin {
    @import '@/collaboration/wireframes/velt-global-style-overrides/comment-bubble.less';
}

.velt-comment-dialog {
    @import '@/collaboration/wireframes/velt-global-style-overrides/comment-composer.less';
}

.velt-comment-dialog {
    @import '@/collaboration/wireframes/velt-global-style-overrides/threads.less';
}

.velt-comment-pin {
    @import '@/collaboration/wireframes/velt-global-style-overrides/comment-pin.less';
}

snippyly-area-pin-portal {
    @import '@/collaboration/wireframes/velt-global-style-overrides/comment-area.less';
}
</style>
